<template>
  <div class="blockChain" ref="refBlockChain">
    <!-- <h1 class="chain-title" id="refTemBox">
      <img src="/images/blockChain/lbg.png" />保全链节点查询
      <img src="/images/blockChain/lbg.png" style="transform: rotate(180deg)" />
    </h1> -->
    <!-- <div class="tem-box">
      <ul class="bl-ul">
        <li
          v-for="(item, index) in chartDataLeval2"
          :key="index"
          :class="{ on: index === activeNode2 }"
          @click="changeNode2(item, index)"
        >
          {{ item.label | noSpace }}
        </li>
      </ul>
      <div class="box">
        <div class="left">
          <charts-chain-graph
            id="chart-chain"
            :chart-data="chartData"
            :hignLightLabel="hignLightLabel"
          />
        </div>
        <div class="right">
          <div class="tc">
            点击下方<br />按钮查询<img src="/images/blockChain/hand.png" />
          </div>
          <ul class="rt-ul">
            <template v-for="(item, index) in chainList">
              <li
                :key="index"
                :title="item.title ? item.title : item.label"
                @click="searchNodeInfo(item)"
              >
                {{ item.label }}
              </li> -->
    <!--              <li v-if="showMore && index>=8" :key="'more'+index" :title="item.label">{{item.label}}</li>-->
    <!-- </template>
            <li
              v-if="!showMore && notSupportList.length > 0"
              @click="
                () => {
                  this.showMore = true;
                  this.chainList = this.showMore
                    ? this.supportList.concat(this.notSupportList)
                    : this.supportList;
                }
              "
            >
              更多
            </li>
          </ul>
        </div>
      </div>
    </div> -->

    <h1 class="chain-title">
      <img src="/images/blockChain/lbg.png" />文件/保全验证
      <img src="/images/blockChain/lbg.png" style="transform: rotate(180deg)" />
    </h1>
    <div class="tem-box">
      <ul class="bl-ul">
        <li class="on">文件验证</li>
        <li @click="openNewWindow('https://www.ebaoquan.org/query')">
          保全验证
        </li>
      </ul>
      <div class="box wb-box">
        <img
          style="width: 563px; margin-top: 70px"
          src="/images/blockChain/file-bg1.png"
        />
        <div class="up-box">
          <div class="textb">
            <h1>
              <span class="ff">方法一：</span
              >点击下方的（上传PDF文件效验）按钮上传需要验证的文档
              <p>将已完成状态的合同文件上传，系统将进行电子合同有效性验证</p>
            </h1>
          </div>
          <div style="display: inline-block">
            <div
              class="upload-box upl"
              @click="clickInputFile"
              v-if="!isHasUpload"
            >
              <i class="el-icon-plus"></i>
              <p>上传pdf格式文件</p>
            </div>
            <div class="upload-box" v-if="isHasUpload">
              <img src="/images/blockChain/pdf.png" style="width: 50px" />
              <h1 @click="clickInputFile">重新上传</h1>
            </div>
            <input
              type="file"
              style="display: none"
              ref="uploadFile"
              @change="changeFile"
            />
          </div>

          <p class="no-signinfo">
            <template v-if="isNoSignInfo">
              <img
                src="/images/blockChain/icon-warn.png"
                style="width: 12px; height: 12px; margin-right: 10px"
              />合同没有签名信息
            </template>
          </p>
          <div class="textb">
            <h1>
              <span class="ff">方法二：</span>使用Adobe Reader
              PDF阅读器验证电子合同的有效性
              <p>
                由于Adobe Reader属于国际型应用，国内CA机构颁发的证书不在Adobe
                Reader的证书信任链接中，同时由于君子签的电子签名使用的是国内CA颁发的CA证书，所以使用AdobeReader进行电子签名有效性验证的时候需要先将国内CA的证书导入到Adobe
                Reader的信任链接中。
              </p>
              <a @click="specificDialogVisible = true">点击查看具体步骤>></a>
            </h1>
          </div>
        </div>
      </div>
    </div>

    <!--    。。。。。。。。。。。。节点查询弹窗start。。。。。。。。。。。。-->
    <!--    易保全节点查询-->
    <el-dialog
      class="com-dialog ym"
      top="10vh"
      title="易保全节点查询"
      :close-on-click-modal="false"
      :visible.sync="ybqDialogVisible"
    >
      <div>
        <div class="a-top">
          <el-input
            :input="certificateCheck(certificateNo)"
            placeholder="输入备案号"
            style="width: 430px; margin-right: 5px"
            v-model="certificateNo"
            clearable
          ></el-input>
          <el-input
            ref="imgAuthInput"
            v-model="imgAuth"
            maxlength="4"
            clearable
            auto-complete="off"
            placeholder="验证码"
            style="width: 240px; position: relative; margin-right: 20px"
          >
            <template slot="append">
              <div @click="getImgAuth">
                <img :src="'data:image/jpeg;base64,' + imgPath" />
              </div>
            </template>
          </el-input>
          <el-button
            style="width: 90px; background: #ec1c1c; color: #ffffff"
            @click="blockQuery"
          >
            <img
              src="../../static/images/blockChain/query.png"
              style="width: 14px; height: 14px; margin-right: 10px"
            />查询
          </el-button>
        </div>
        <span v-if="hint" style="color: #ec1c1c; font-size: 14px"
          >存证备案号只能是数字</span
        >

        <template v-if="recordNo">
          <div class="blockInfo">
            <el-row class="info">
              <el-col class="infoTitle">保全备案号:</el-col>
              <el-col class="infoValue">{{
                recordNo | leftPad(10, "0")
              }}</el-col>
            </el-row>
            <el-row class="info">
              <el-col class="infoTitle">保全主体名称:</el-col>
              <el-col class="infoValue">{{ subjectName }}</el-col>
            </el-row>
            <el-row class="info">
              <el-col class="infoTitle">保全主体证件:</el-col>
              <el-col class="infoValue">{{ subjectCard }}</el-col>
            </el-row>
            <el-row class="info">
              <el-col class="infoTitle">操作用户名称:</el-col>
              <el-col class="infoValue">{{ userName }}</el-col>
            </el-row>
            <el-row class="info">
              <el-col class="infoTitle">操作用户证件:</el-col>
              <el-col class="infoValue">{{ userCard }}</el-col>
            </el-row>
            <el-row
              style="height: 1px; border: 1px solid #e4e4e4; margin: 10px 0"
            >
            </el-row>
            <el-row class="info">
              <el-col class="infoTitle">保全时间戳:</el-col>
              <el-col class="infoValue">{{
                timestamp | formatDateTime2()
              }}</el-col>
            </el-row>
          </div>
          <div class="blockInfo">
            <el-row class="info">
              <el-col class="infoTitle">保全文件Hash:</el-col>
              <el-col class="infoValue">{{ sha512Hash }}</el-col>
            </el-row>
            <el-row class="info">
              <el-col class="infoTitle">易保全链交易Hash:</el-col>
              <el-col class="infoValue">{{ transactionHash }}</el-col>
            </el-row>
            <el-row class="info">
              <el-col class="infoTitle">易保全链区块Hash:</el-col>
              <el-col class="infoValue">{{ blockHash }}</el-col>
            </el-row>
            <el-row class="info">
              <el-col class="infoTitle">工信部标识解析:</el-col>
              <el-col class="infoValue">{{
                humiId || "数据同步需要时间，请稍后再查"
              }}</el-col>
            </el-row>
            <!--              <el-row class="info">-->
            <!--              <el-col class="infoTitle">广互法院证据编号:</el-col>-->
            <!--              <el-col class="infoValue">{{evidenceNo || '数据同步需要时间，请稍后再查'}}</el-col>-->
            <!--            </el-row>-->
          </div>
        </template>
        <template v-else>
          <div style="padding: 80px 0 65px">
            <img
              src="../../static/images/blockChain/noData.png"
              style="
                width: 440px;
                height: 250px;
                margin: 0 auto;
                display: block;
              "
            />
            <p
              style="
                font-size: 14px;
                color: rgba(41, 2, 2, 0.65);
                text-align: center;
              "
            >
              暂无结果，请输入存证备案号进行查询
            </p>
          </div>
        </template>
      </div>

      <el-row slot="footer" class="dialog-footer">
        <!--        <el-button size="mini" @click="ybqDialogVisible = false">取消</el-button>-->
        <el-button size="mini" type="primary" @click="ybqDialogVisible = false"
          >确定</el-button
        >
      </el-row>
    </el-dialog>

    <!--    互联网法院节点查询-->
    <el-dialog
      class="com-dialog ym"
      top="10vh"
      title="互联网法院节点查询"
      :close-on-click-modal="false"
      :visible.sync="internetDialogVisible"
    >
      <div class="con-box">
        <h1 style="margin-bottom: 10px">查询指南</h1>
        <p style="margin-bottom: 10px">
          由于互联网法院的特殊性，需按以下步骤查询：
        </p>
        <p class="stp-wrap">
          <span class="stp">1</span
          >先通过证据编号在其他区块链节点查询到互联网法院证据编号；
        </p>
        <div class="img-wrap">
          <img src="/images/blockChain/inter-step1.png" />
        </div>
        <p class="stp-wrap">
          <span class="stp">2</span>得到互联网法院证据编号后，登录互联网法院：<a
            href="https://www.gzinternetcourt.gov.cn"
            target="_blank"
            >www .gzinternetcourt.gov.cn</a
          >
          ，在添加证据时选择可信电子凭证平台，输入相应证据编号即可验证。
        </p>
        <div class="img-wrap">
          <img src="/images/blockChain/inter-step2.png" />
        </div>
      </div>

      <el-row slot="footer" class="dialog-footer">
        <!--        <el-button size="mini" @click="ybqDialogVisible = false">取消</el-button>-->
        <el-button
          size="mini"
          type="primary"
          @click="internetDialogVisible = false"
          >确定</el-button
        >
      </el-row>
    </el-dialog>

    <!--    节点查询未开通-->
    <el-dialog
      class="com-dialog notK"
      top="10vh"
      title="提示"
      :close-on-click-modal="false"
      :visible.sync="notKDialogVisible"
    >
      <div class="notk-box">
        <img src="/images/blockChain/expect.png" />
        <span style="display: inline-block; width: 196px"
          >该节点线上查询功能暂未开通， 敬请期待！</span
        >
      </div>

      <el-row slot="footer" class="dialog-footer">
        <!--        <el-button size="mini" @click="ybqDialogVisible = false">取消</el-button>-->
        <el-button size="mini" type="primary" @click="notKDialogVisible = false"
          >确定</el-button
        >
      </el-row>
    </el-dialog>
    <!--    。。。。。。。。。。。。节点查询弹窗end。。。。。。。。。。。。-->

    <!--    文件/保全验证具体步骤-->
    <el-dialog
      class="com-dialog ym"
      top="10vh"
      title="方法二具体步骤"
      :close-on-click-modal="false"
      :visible.sync="specificDialogVisible"
    >
      <div class="con-box">
        <p class="stp-wrap" style="margin-bottom: 20px">
          <span class="stp">1</span>在您的电脑上安装Adobe Reader
          PDF阅读器（若已安装，直接进行第二步操作） 您可以登录Adobe
          Reader的官方软件下载此软件。官方下载链接为：<a
            href="https://acrobat.adobe.com/cn/zh-Hans/acrobat/pdf-reader.html"
            target="_blank"
            >https://acrobat.adobe .com/cn/zh-Hans/acrobat/pdf-reader.html</a
          >
        </p>
        <p class="stp-wrap">
          <span class="stp">2</span>验证电子签名合同：使用Adobe Reader
          PDF阅读器打开需要验证的文档，找到合同中的电子签章后，点击电子签章，即可查看电子签章的有效性，如下图所示：
        </p>
        <div class="img-wrap" style="text-align: left">
          <img
            src="/images/blockChain/fileVerify-step1.png"
            style="width: 388px; height: auto; display: inline-block"
          />
        </div>
        <p class="stp-wrap">
          点击“签名属性”按钮，可以查看该电子签名的其他有效信息，如下图所示：
        </p>
        <div class="img-wrap">
          <img
            src="/images/blockChain/fileVerify-step2.png"
            style="width: 370px; display: inline-block; margin-right: 20px"
          />
          <img
            src="/images/blockChain/fileVerify-step3.png"
            style="width: 370px; display: inline-block; vertical-align: top"
          />
        </div>
      </div>

      <el-row slot="footer" class="dialog-footer">
        <!--        <el-button size="mini" @click="specificDialogVisible = false">取消</el-button>-->
        <el-button
          size="mini"
          type="primary"
          @click="specificDialogVisible = false"
          >确定</el-button
        >
      </el-row>
    </el-dialog>

    <!--    文件/保全验证查询结果-->
    <el-dialog
      class="com-dialog ym"
      top="10vh"
      title="查询结果"
      :close-on-click-modal="false"
      :visible.sync="searchResultVisible"
    >
      <div class="con-box" v-html="searchInfo"></div>
    </el-dialog>

    <a href="https://dms.citln.cn/"></a>
  </div>
</template>
<script>
import { postImgCode } from "../../assets/js/http-serve/http-methods";
import BlockChain from "../../assets/js/http-serve/blockChain";
import chartsChainGraph from "@/components/charts/charts-chain-graph";
import { isInDingTalk } from '@/assets/js/utils/ding-env'

export default {
  name: "index",
  components: { chartsChainGraph },
  data () {
    return {
      certificateNo: "",
      recordNo: "",
      subjectCard: "",
      subjectName: "",
      userCard: "",
      userName: "",
      timestamp: "",
      sha512Hash: "",
      evidenceNo: "",
      transactionHash: "",
      blockHash: "",
      humiId: "",
      hint: false,
      imgAuth: "",
      imgPath: "",
      imgToken: "",
      // 关系图数据
      chartData: [
        /* 原始数据 供参考*/
        /*{
          label: '保全链',
          level: 1,
          color: ['#010D71', '#0B36FB'],
          children: [

            {
              label: '易保全',
              level: 2,
              color: ['#102EB5', '#3E61FF'],
              children: [
                {
                  label: '重庆易保全网络科技有限公司',
                  level: 3,
                  onlineSearch: true, // 支持在线查询，（不支持的显示在更多内）
                  handleClick: () => {
                    this.ybqDialogVisible = true;
                  },
                },
              ],
            },

            {
              label: '仲裁委',
              level: 2,
              color: ['#1C174A', '#00B0FD'],
              children: [
                {
                  label: '深汕仲裁委',
                  level: 3,
                  labelOffset: [-25, -25],
                  link: 'http://swzcw.aihuz.com/#/login',
                  onlineSearch: true, // 支持在线查询，（不支持的显示在更多内）
                },
                {
                  label: '十堰仲裁委',
                  level: 3,
                  link: 'http://syac.aihuz.com/#/login',
                  onlineSearch: true, // 支持在线查询，（不支持的显示在更多内）
                },
                {
                  label: '赣国仲裁委',
                  level: 3,
                  link: 'http://iacg.aihuz.com/#/login',
                  onlineSearch: true, // 支持在线查询，（不支持的显示在更多内）
                },
                {
                  label: '广州仲裁委',
                  level: 3,
                },
                {
                  label: '珠海仲裁委',
                  level: 3,
                },
                {
                  label: '盐城仲裁委',
                  level: 3,
                  labelPosition: 'right', // 方向
                  labelOffset: [-20, 25],
                },
                {
                  label: '安阳仲裁委',
                  level: 3,
                  labelPosition: 'left', // 方向
                  labelOffset: [20, 25],
                },
                {
                  label: '宁波仲裁委',
                  level: 3,
                  labelPosition: 'left', // 方向
                },
                {
                  label: '中卫仲裁委',
                  level: 3,
                  labelPosition: 'left', // 方向
                },
                {
                  label: '青岛仲裁委',
                  level: 3,
                  labelPosition: 'left', // 方向
                },
                {
                  label: '哈尔滨仲裁委',
                  level: 3,
                  labelPosition: 'left', // 方向
                },
                {
                  label: '庆阳仲裁委',
                  level: 3,
                  labelPosition: 'left', // 方向
                },
                {
                  label: '台州仲裁委',
                  level: 3,
                  labelPosition: 'left', // 方向
                  labelOffset: [15, -25],
                },
              ],
            },

            {
              label: '版权\n机构',
              level: 2,
              color: ['#651A15', '#D67973'],
              children: [
                {
                  label: '首都知识产权局',
                  level: 3,
                  labelPosition: 'left', // 方向
                  link: 'http://web.capitalip.org/chain.html',
                  onlineSearch: true, // 支持在线查询，（不支持的显示在更多内）
                },
                {
                  label: '重庆市版权保护中心',
                  level: 3,
                  labelPosition: 'left', // 方向
                  labelOffset: [10, -20],
                },
                {
                  label: '贵州省版权局登记平台',
                  level: 3,
                  labelOffset: [-10, -20],
                },
              ],
            },

            {
              label: '公证处',
              level: 2,
              color: ['#013426', '#11CB8F'],
              children: [
                {
                  label: '山西太原市城南公证处',
                  level: 3,
                  link: 'http://cngzc.sfj.taiyuan.gov.cn/web/index.html#/chain',
                  onlineSearch: true, // 支持在线查询，（不支持的显示在更多内）
                },

              ],
            },

            {
              label: '法院',
              level: 2,
              color: ['#2A019A', '#6E3AFB'],
              children: [
                // {
                //   label: '广州互联网法院',
                //   level: 3,
                //   onlineSearch: true, // 支持在线查询，（不支持的显示在更多内）
                //   handleClick: () => {
                //     this.internetDialogVisible = true;
                //   },
                // },
                 {
                  label: '山西省太原市晋源区人民法院',
                  level: 3,
                  onlineSearch: true, // 支持在线查询，（不支持的显示在更多内）
                 link: 'http://114.116.232.9:8888/#/login',
                },
              ],
            },
            {
              label: '\n工信部\n',
              level: 2,
              color: ['#2A019A', '#6E3AFB'],
              children: [
                {
                  label: '工信部',
                  title: '查询前在《存证证书》 \n中获取并复制该标识',
                  level: 3,
                  labelPosition: 'right', // 方向
                  onlineSearch: true, // 支持在线查询，（不支持的显示在更多内）
                  link: 'https://dms.citln.cn/',
                },
              ],
            },
          ],
        },*/
      ],

      chartDataLeval2: [], // 二级节点数据
      chartDataLeval3: [], // 三级节点数据
      activeNode2: 0,
      hignLightLabel: "",
      showMore: false,
      ybqDialogVisible: false, // 易保全节点弹窗
      internetDialogVisible: false, // 互联网法院节点查询弹窗
      notKDialogVisible: false, // 节点查询未开通弹窗
      // 文件/保全验证
      specificDialogVisible: false, // 文件/保全验证具体步骤弹窗
      searchResultVisible: false, // 文件/保全验证查询结果弹窗
      isNoSignInfo: false,
      isHasUpload: false,
      searchInfo: "", // 查询结果
      chainList: [], // 右边列表节点对象
      supportList: [], // 是否支持在线查询
      notSupportList: [] //（不支持的显示在更多内
    };
  },

  filters: {
    noSpace: function (value) {
      if (!value) return "";
      return value.replace(/\s|\n/g, "");
    }
  },
  computed: {
    /**
     *  根据二级保全链节点过滤出他的子节点
     * */
    filterNodeList3 () {
      let returnArr = [];
      let currentSelect = this.chartDataLeval2[this.activeNode2];

      if (currentSelect && currentSelect.type === "all") {
        // 全部
        returnArr = this.chartDataLeval3;
      } else {
        returnArr = this.chartDataLeval3.filter(
          item => item.parentLabel == currentSelect.label
        );
      }
      let filterArr = returnArr.filter(item => item.onlineSearch);
      // let onlineSearchArr = returnArr.filter(item => item.onlineSearch); // 是否支持在线查询
      // let notOnlineSearchArr = returnArr.filter(item => !item.onlineSearch); //（不支持的显示在更多内）
      console.log(filterArr);
      let onlineSearchArr = filterArr.slice(0, 9); // 是否支持在线查询
      let notOnlineSearchArr = filterArr.slice(9); //（不支持的显示在更多内
      if (this.showMore) {
        // 显示更多
        return {
          list: onlineSearchArr.concat(notOnlineSearchArr),
          supportList: onlineSearchArr,
          notSupportList: notOnlineSearchArr
        };
      } else {
        return {
          list: onlineSearchArr,
          supportList: onlineSearchArr,
          notSupportList: notOnlineSearchArr
        };
      }
    }
  },
  created () {
    this.getImgAuth();
    this.getAllNodeTree();
    this.getChainList();
    let presId = this.$route.query ? this.$route.query.presId : null;
    if (presId) {
      this.ybqDialogVisible = true;
      this.certificateNo = presId;
      this.$nextTick(() => {
        document.getElementById("refTemBox").scrollIntoView();
      });
      this.blockQuery();
    }
  },
  methods: {
    // 获取所有节点数据
    getAllNodeTree () {
      BlockChain.getChainNodeTree()
        .then(res => {
          if (res.status !== 200)
            return this.$message.error("获取当前数据节点失败");
          let dataList = res.data;
          dataList[0].children.map(v => {
            if (v.children.length > 0) {
              v.children.map(vv => {
                vv.onlineSearch = vv.searchAble ? true : false;
                if (vv.code === "101010") {
                  vv.handleClick = () => {
                    this.ybqDialogVisible = true;
                  };
                }
              });
            }
          });
          this.chartData = dataList;
          // 获取节点数据
          this.chartDataLeval2 = [
            { label: "全部", type: "all" },
            ...this.getBQNodesList(2)
          ];
          this.chartDataLeval3 = this.getBQNodesList(3);
        })
        .catch(err => console.error(err));
    },
    getImgAuth: function () {
      postImgCode(1).then(data => {
        this.imgPath = data.data.imgPath;
        this.imgToken = data.data.imgToken;
      });
    },
    blockQuery () {
      this.resetQuery();
      if (!this.certificateNo) {
        this.$message.warning("存证备案号不能为空");
        this.resetQuery();
        return;
      }
      if (this.certificateNo.length !== 10) {
        this.$message.warning("请正确输入10位数的备案号");
        this.resetQuery();
        return;
      }
      if (this.hint) {
        this.$message.error("存证备案号格式有误");
        this.resetQuery();
        return;
      }
      if (!this.imgAuth) {
        this.$message.error("验证码不能为空");
        return;
      }
      BlockChain.presChainDetail(
        this.certificateNo,
        1,
        this.imgToken + "_" + this.imgAuth
      ).then(res => {
        if (res.data.success) {
          this.recordNo = res.data.data.preservationId;
          this.subjectCard = res.data.data.entityId;
          this.subjectName = res.data.data.entityId;
          this.userCard = res.data.data.operatorEntityId;
          this.userName = res.data.data.operatorEntityId;
          this.timestamp = res.data.data.preservationTime;
          this.sha512Hash = res.data.data.sha512Hash;
          this.evidenceNo = res.data.data.gznetId;
          this.transactionHash = res.data.data.trans.hash;
          this.blockHash = res.data.data.block.hash;
          this.humiId = res.data.data.humiId;
          this.getImgAuth();
        } else {
          if (res.data.code === "10602") {
            this.$message.error("图形验证码错误");
            this.getImgAuth();
            return;
          }
          this.$message.warning("查询失败" || res.data.description);
          this.getImgAuth();
        }
      });
    },
    // 清空结果
    resetQuery () {
      this.recordNo = "";
      this.subjectCard = "";
      this.subjectName = "";
      this.userCard = "";
      this.userName = "";
      this.timestamp = "";
      this.sha512Hash = "";
      this.evidenceNo = "";
      this.transactionHash = "";
      this.blockHash = "";
      this.humiId = "";
    },
    certificateCheck (no) {
      var reg = /^[0-9]*$/;
      const show = reg.test(no);
      if (!show) {
        this.hint = !show;
      } else {
        this.hint = !show;
      }
    },
    // 。。。。。。。。。。。。。保全链节点查询start。。。。。。。。。。。。。。。。
    /**
     *  获取节点数据
     *  @level 节点级别
     * */
    getBQNodesList (level) {
      let arr = [];
      let dgListFn = function (list, parentNode) {
        list.map(item => {
          if (item.level == level) {
            arr.push({
              ...item,
              parentLabel: parentNode ? parentNode.label : ""
            });
          } else {
            if (item.children && item.children.length > 0) {
              dgListFn(item.children, item);
            }
          }
        });
      };
      dgListFn(this.chartData);
      return arr;
    },
    /**
     *  切换保全链节点查询tab
     * */
    changeNode2 (item, index) {
      this.activeNode2 = index;
      this.showMore = false;
      if (item.type == "all") {
        // 全部
        this.hignLightLabel = "";
      } else {
        this.hignLightLabel = item.label;
      }
      this.getChainList(item.code);
    },
    // 获取右边展示列表数据
    getChainList (code = "") {
      BlockChain.getChainNodeList(code).then(res => {
        let chainArr = res.data;
        let onlineSearchArr = chainArr.slice(0, 9); // 是否支持在线查询
        let notOnlineSearchArr = chainArr.slice(9); //（不支持的显示在更多内
        this.chainList = this.showMore
          ? onlineSearchArr.concat(notOnlineSearchArr)
          : onlineSearchArr;
        this.supportList = onlineSearchArr;
        this.notSupportList = notOnlineSearchArr;
      });
    },
    openNewWindow (link) {
      isInDingTalk ? location.href = link : window.open(link, "_blank");
    },
    // 保全链节点查询
    searchNodeInfo (item) {
      if (item.onlineSearch) {
        if (item.linkPc && item.code !== "101010") {
          this.openNewWindow(item.linkPc);
        } else if (item.handleClick) {
          item.handleClick();
        }
      } else {
        // 节点查询未开通
        this.notKDialogVisible = true;
      }
    },
    // 。。。。。。。。。。。。。保全链节点查询end。。。。。。。。。。。。。。。。
    clickInputFile () {
      this.$refs["uploadFile"].click();
    },
    changeFile (e) {
      let file = e.target.files[0];
      this.isNoSignInfo = false;
      if (file.type == "application/pdf") {
        if (file.size > 30 * 1024 * 1024) {
          this.$message({
            customClass: "com-message",
            type: "error",
            showClose: true,
            message: "上传文件不能超过30M"
          });
        } else {
          this.isHasUpload = true;
          BlockChain.validateContract(file)
            .then(res => {
              res = res.data;
              if (res.success) {
                let data = res.data;
                if (data.length == 0) {
                  this.isNoSignInfo = true;
                } else {
                  let html = "";
                  let index = 0;
                  for (var j = 0; j < data.length; j++) {
                    for (
                      var i = 0;
                      i < data[j].contractCertificateInfos.length;
                      i++
                    ) {
                      index++;
                      html += `
                                <table class="dialog-table">
          <tr class="first">
            <td class="first" colspan="2">签章${index}</td>
          </tr>
          <tr>
            <td class="first" width="100px">签署人</td>
            <td>${data[j].signName}</td>
          </tr>
          <tr>
            <td class="first">签署时间</td>
            <td>${data[j].signDate}</td>
          </tr>
          <tr>
            <td class="first">颁发机构</td>
            <td>${data[j].contractCertificateInfos[i].certificateIssuer}
            </td>
          </tr>
          <tr>
            <td class="first">证书拥有者</td>
            <td>${data[j].contractCertificateInfos[i].certificateOwner}</td>
          </tr>
          <tr>
            <td class="first">有效日期</td>
            <td>${data[j].contractCertificateInfos[i].certificateBeginTimeFormat} 至 ${data[j].contractCertificateInfos[i].certificateEndTimeFormat}</td>
          </tr>
        </table>
                            `;
                    }
                  }

                  this.searchInfo = html;
                  this.searchResultVisible = true;
                }
              } else {
                this.$message({
                  type: "info",
                  showClose: true,
                  message: res.description
                });
              }
            })
            .catch(error => {
              this.isHasUpload = false;
              console.error(error);
            });
        }
      } else {
        this.$message({
          customClass: "com-message",
          type: "error",
          showClose: true,
          message: "请上传pdf格式的文件"
        });
      }
      // 清空input值
      this.$refs["uploadFile"].value = "";
    }
  }
};
</script>

<style scoped lang="less">
.blockChain {
  width: 1200px;
  margin: 10px auto 20px;

  .black {
    display: inline-block;
    width: 7px;
    height: 20px;
    background: #290202;
    margin-right: 10px;
  }

  span {
    font-size: 20px;
    font-weight: bold;
    color: #290202;
  }

  .blockInfo {
    padding: 30px 25px 0;
    max-height: 390px;
    overflow-x: hidden;
    overflow-y: auto;

    .info {
      margin-bottom: 15px;
      display: flex;
      align-items: center;

      .infoTitle {
        width: 150px;
        font-size: 14px;
        margin-right: 6px;
        color: rgba(41, 2, 2, 0.65);
      }

      .infoValue {
        font-size: 14px;
        color: #290202;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

/deep/ .el-button {
  border: 0;

  &:hover {
    opacity: 0.7;
  }
}

/deep/ .el-input-group__append,
.el-input-group__prepend {
  background: none;
  border: 0;
  width: 75px;
  height: 30px;
  padding: 0;
  position: absolute;
  top: 1px;
  right: 0;
  cursor: pointer;

  img {
    height: 38px;
  }
}

.chain-title {
  text-align: center;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ec1c1c;
  margin-bottom: 65px;

  img {
    width: 164px;
    height: 24px;
  }

  img:nth-of-type(1) {
    margin-right: 20px;
  }

  img:nth-of-type(2) {
    margin-left: 10px;
  }
}

.tem-box {
  z-index: 2;
  width: 1200px;
  height: 700px;
  background: #ffffff;
  border-radius: 10px;
  padding: 19px;
  box-sizing: border-box;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.16);
  position: relative;
  margin-bottom: 72px;

  .box {
    width: 100%;
    height: 100%;
    background: #18143f;
    border-radius: 10px;
    box-shadow: 0px 0px 12px rgba(28, 23, 74, 0.76);
    padding-right: 110px;
    box-sizing: border-box;
    position: relative;

    .left {
      width: 100%;
      height: 100%;
      background: #1c174a;
    }

    .right {
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      width: 110px;
      text-align: center;
    }
  }

  .wb-box {
    background: url("/images/blockChain/bg2.png") no-repeat center center;
    background-size: cover;
    padding-right: 0;
    text-align: center;

    .up-box {
      width: 678px;
      height: 483px;
      display: block;
      margin: 19px auto 0 auto;
      background: url("/images/blockChain/file-bg2.png") no-repeat center center;
      background-size: cover;
      box-sizing: border-box;
      padding-top: 50px;

      .textb {
        padding-left: 144px;
        padding-right: 65px;
        box-sizing: border-box;
        width: 100%;
        position: relative;
        margin-bottom: 30px;
      }

      h1 {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: bold;
        line-height: 22px;
        color: #00b0fd;
        position: relative;
        text-align: left;

        .ff {
          font-size: inherit;
          position: absolute;
          top: 0;
          left: -75px;
          color: #00b0fd;
        }

        p {
          font-size: 12px;
          font-weight: normal;
          color: rgba(0, 176, 253, 0.65);
          text-align: left;
        }

        a {
          font-weight: bold;
          cursor: pointer;
          color: #00b0fd;
          font-size: inherit;
          margin-top: 5px;
          display: inline-block;

          &:hover {
            color: rgba(236, 28, 28, 1);
          }
        }
      }
    }

    .upload-box {
      width: 175px;
      height: 140px;
      border: 1px solid #00b0fd;
      opacity: 1;
      border-radius: 4px;
      display: block;
      margin: 0 auto;
      background-color: rgba(6, 127, 194, 0.25);
      color: #00b0fd;
      padding-top: 30px;
      box-sizing: border-box;
      cursor: pointer;
      position: relative;

      &.upl:hover {
        color: #ec1c1c;
        background-color: rgba(236, 28, 28, 0.15);
        border: 1px solid #ec1c1c;
      }

      /deep/ .el-icon-plus {
        font-size: 55px;
        color: inherit;
      }

      p {
        color: inherit;
        font-size: 12px;
        margin-top: 10px;
      }

      h1 {
        position: absolute;
        width: 100%;
        height: 34px;
        line-height: 34px;
        background: #0c5a97;
        border-radius: 0px 0px 3px 3px;
        font-size: 14px;
        left: 0;
        bottom: 0;
        text-align: center;
        cursor: pointer;

        &:hover {
          color: rgba(236, 28, 28, 1);
        }
      }
    }
  }
}

.tc {
  /*border: 1px dashed rgba(158, 155, 214, 0.7);*/
  background: url("/images/blockChain/text-bg.png") no-repeat center center;
  background-size: cover;
  font-size: 12px;
  font-family: Source Han Sans SC;
  font-weight: 300;
  color: #9e9bd6;
  text-align: center;
  width: 85px;
  height: 108px;
  margin: 20px auto 0;
  box-sizing: border-box;
  padding: 10px;

  img {
    width: 20px;
    display: block;
    margin: 20px auto 0;
  }
}

// tab样式
.bl-ul {
  z-index: 4;
  position: absolute;
  left: 30px;
  right: 30px;
  top: -16px;
  display: block;
  text-align: left;
  list-style: none;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  margin: 0 auto;
  box-sizing: border-box;

  li {
    cursor: pointer;
    display: inline-block;
    text-align: center;
    list-style: none;
    width: 150px;
    height: 47px;
    line-height: 47px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #290202;
    /*margin-left: 8px;*/
    /*background: linear-gradient(180deg, #C2C2C2 0%, #FFFFFF 0%, #FFFFFF 83%, #BFBFBF 100%);*/
    border-radius: 0px 0px 6px 6px;
    background: url("/images/blockChain/t-bg.png") no-repeat center center;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding-right: 14px;
    /*box-shadow: -5px 0px 12px rgba(0, 0, 0, 0.16);*/
    box-shadow: -5px 0 10px -5px rgba(0, 0, 0, 0.16);

    &:first-child {
      margin-left: 0;
    }

    &:hover {
      font-weight: bold;
      color: #ec1c1c;
    }

    &.on {
      font-weight: bold;
      color: #ec1c1c;
    }
  }
}

.rt-ul {
  list-style: none;
  display: inline-block;
  margin: 20px auto 0 auto;
  max-height: 480px;
  overflow-x: hidden;
  overflow-y: auto;

  li {
    list-style: none;
    box-sizing: border-box;
    padding: 0 5px;
    width: 80px;
    height: 35px;
    line-height: 35px;
    background: rgba(59, 56, 148, 0.39);
    border-radius: 100px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.65);
    cursor: pointer;
    margin-bottom: 10px;

    &:hover {
      /*font-weight: bold;*/
      color: #ec1c1c;
    }

    &.on {
      /*font-weight: bold;*/
      color: #ec1c1c;
    }
  }
}

.a-top {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.no-signinfo {
  text-align: center;
  padding: 15px 0 15px 0;
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #ff8800;
  height: 50px;
  box-sizing: border-box;
}

/deep/ .dialog-table {
  width: 100%;
  border: 1px solid #e5e5e5;
  border-collapse: collapse;
  margin-bottom: 30px;

  tr {
    text-align: center;
    height: 40px;
    line-height: 40px;
    border: 1px solid #e5e5e5;
  }

  .first {
    background: #f2f2f2;
  }

  td {
    border: 1px solid #e5e5e5;
    font-size: 12px;
    font-weight: 400;
    color: rgba(41, 2, 2, 0.65);
  }
}

.con-box {
  height: 480px;
  overflow-x: hidden;
  overflow-y: auto;

  h1 {
    text-align: center;
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    color: rgba(41, 2, 2, 0.65);
  }

  p {
    text-align: left;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: rgba(41, 2, 2, 0.65);
    margin-bottom: 10px;
    box-sizing: border-box;
    position: relative;

    &.stp-wrap {
      padding-left: 24px;
      padding-right: 22px;

      .stp {
        position: absolute;
        left: 0;
        top: 0;
      }
    }

    a {
      color: rgba(236, 28, 28, 1);
      margin-left: 5px;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }

    .stp {
      display: inline-block;
      width: 18px;
      height: 18px;
      line-height: 18px;
      border-radius: 50%;
      text-align: center;
      margin-right: 3px;
      background-color: rgba(236, 28, 28, 1);
      color: #ffffff;
      font-size: 12px;
      font-weight: bold;
    }
  }

  .img-wrap {
    padding: 0 20px 20px 22px;
    box-sizing: border-box;
  }

  img {
    display: block;
    width: 100%;
  }
}

.com-dialog {
  &.ym {
    /deep/ .el-dialog {
      width: 980px;
    }
  }

  &.notK {
    /deep/ .el-dialog {
      width: 475px;
    }

    .notk-box {
      img {
        width: 218px;
        display: inline-block;
        vertical-align: middle;
      }

      span {
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        line-height: 20px;
        color: #290202;
        vertical-align: middle;
      }
    }
  }

  /deep/ .el-dialog__body {
    box-sizing: border-box;
  }

  /deep/ .el-dialog__footer {
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.17);
    padding: 10px 15px;
  }
}
</style>



// WEBPACK FOOTER //
// pages/blockChain/index.vue